import React, { useState } from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import { deleteMultipleNotifications, markMultipleNotificationsAsRead } from "../../../services/notification.service";
import { showSuccess, showError } from "../../../services/toast.service";
import eventEmitter from "../../../services/event.service";

const Panel = ({ selectedNotifications = [], onDelete, onMarkAsRead }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [isMarking, setIsMarking] = useState(false);
  const count = selectedNotifications.length;
  
  if (count === 0) {
    return null;
  }
  
  const handleDelete = async () => {
    setIsDeleting(true);
    
    try {
      // Suppression des notifications sélectionnées
      await deleteMultipleNotifications(selectedNotifications);
      
      // Notifier le composant parent (qui affichera le message de succès)
      if (onDelete) {
        onDelete(selectedNotifications);
      }
      
      // Déclencher l'événement pour rafraîchir la liste est géré par le parent
      // eventEmitter.dispatch('notificationsUpdated');
    } catch (error) {
      showError(`Erreur lors de la suppression des notifications: ${error.message}`);
    } finally {
      setIsDeleting(false);
    }
  };
  
  const handleMarkAsRead = async () => {
    setIsMarking(true);
    
    try {
      // Marquer uniquement les notifications sélectionnées comme lues
      await markMultipleNotificationsAsRead(selectedNotifications);
      
      // Notifier le composant parent (qui affichera le message de succès)
      if (onMarkAsRead) {
        onMarkAsRead(selectedNotifications);
      }
      
      // Déclencher l'événement pour rafraîchir la liste
      // eventEmitter.dispatch('notificationsUpdated'); // Supprimé car déjà fait par le parent
    } catch (error) {
      showError(`Erreur lors du marquage des notifications: ${error.message}`);
    } finally {
      setIsMarking(false);
    }
  };
  
  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <span>{count} notification{count > 1 ? 's' : ''}</span> sélectionnée{count > 1 ? 's' : ''}
      </div>
      <div className={styles.actions}>
        <button 
          className={cn("button-stroke", styles.button)} 
          onClick={handleMarkAsRead} 
          disabled={isMarking}
        >
          {isMarking ? 'Marquage...' : `Marquer comme lu${count > 1 ? 'es' : ''}`}
        </button>
        <button 
          className={cn("button", styles.button)} 
          onClick={handleDelete} 
          disabled={isDeleting}
        >
          {isDeleting ? 'Suppression...' : 'Supprimer'}
        </button>
      </div>
    </div>
  );
};

export default Panel;
